import { Flex, chakra, Image, Link } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';

const DiverBanner = ({ className }: { className?: string }) => {
  const largestNum = 3;
  const [ randomNum, setRandomNum ] = useState(1);

  useEffect(() => {
    const num = Math.floor(Math.random() * largestNum) + 1;
    setRandomNum(num);
  }, []);

  const externalLink = 'https://diver.domains/';

  return (
    <>
      <Flex className={ className } display={{ base: 'none', lg: 'flex' }}>
        <Link href={ externalLink } isExternal>
          <Image src={ `/assets/adBanners/desktop/domain-banner-${ randomNum }.jpg` } alt=""/>
        </Link>
      </Flex>
      <Flex className={ className } display={{ base: 'flex', lg: 'none' }}>
        <Link href={ externalLink } isExternal>
          <Image src={ `/assets/adBanners/mobile/domain-banner-${ randomNum }.jpg` } alt=""/>
        </Link>
      </Flex>
    </>
  );
};

export default chakra(DiverBanner);
